import { computedFrom } from "aurelia-binding";
import { autoinject } from "aurelia-dependency-injection";
import { IOrderMetaPlugin } from "../../../../../models/rightstore/rightstore.models";
import { ManageVesselService } from "../../../../../services/vessels/manage-vessel.service";
import { VesselDetailModel } from "../../../../../models/vessels/vessel.models";

@autoinject()
export abstract class BaseVetOrder implements IOrderMetaPlugin
{
    private _vesselId: number;
    public canBeVetted: boolean = false;

    public abstract viewTitle: string;
    public abstract canSubmit: boolean;
    public abstract isValid(): Promise<boolean>;
    public abstract getMetaModel();
    protected onVesselSelectedInternal: (vessel) => void;
    protected abstract disableSubmitInternal: boolean;
    public canEditVessel: boolean;
    public vessel: VesselDetailModel;
    
    @computedFrom("canBeVetted", "disableSubmitInternal")
    public get disableSubmit(): boolean
    {
        return !this.canBeVetted || this.disableSubmitInternal;
    }

    @computedFrom("_vesselId")
    public get vesselId(): number
    {
        return this._vesselId;
    }

    public set vesselId(value: number)
    {
        this._vesselId = value;
        if(this.vesselId)
        {
            this.canBeVetted = true;
            this.vesselService.canVesselBeVetted(this.vesselId)
            .then(x => {
                this.canBeVetted = x;
            })
            .catch(() => 
            {
                this.canBeVetted = false;
            });
        }
        else 
        {
            this.canBeVetted = false;
        }
    }

    constructor(protected vesselService: ManageVesselService)
    {

    }

    public async onVesselSelected(vessel: any) {
        this.vesselId = vessel ? vessel.id : null;
        this.setVessel(vessel);
        if(this.onVesselSelectedInternal)
            this.onVesselSelectedInternal(vessel);
    }

    protected setVessel(vessel: any)
    {
        if (!vessel) return;
        if (!this.vessel && vessel != null) this.vessel = <VesselDetailModel>{};
        //if same vessel id update values when not not null else use current values
        const current = this.vessel.vesselId == vessel?.id? this.vessel : null;
        this.vessel.vesselId = vessel ? vessel.id : null;
        this.vessel.europeanNumberOfIdentification = vessel?.europeanNumberOfIdentification ?? current?.europeanNumberOfIdentification;
        this.vessel.vehicleIdentificationNumber = vessel?.vehicleIdentificationNumber ?? current?.vehicleIdentificationNumber;
        this.vessel.internationalMaritimeOrganizationNumber = vessel?.internationalMaritimeOrganizationNumber ?? current?.internationalMaritimeOrganizationNumber;
        this.vessel.name = vessel?.name ?? current?.name;
        this.vessel.cargoTypeCategoryId = vessel?.vesselCargoTypeCategory ?? current?.cargoTypeCategoryId;
    }

    //Returns today's date
    public today() {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return today;
    }
}